<template>
  <div class="dlg">
    <header class="dlg__head">
      <div class="dlg__eyebrow">
        <span class="dlg__dot"></span>
        WAIZMANNVERGLEICH / ERGEBNIS TEILEN
      </div>
      <h2 class="dlg__title">
        Ergebnis teilen
        <span class="bt-id">· Nr. {{ berechnung.ber_id }}</span>
      </h2>
      <p class="dlg__sub">
        Kopieren oder scannen Sie diesen Link, um das Berechnungsergebnis mit
        anderen Personen zu teilen.
      </p>
    </header>

    <div class="bt-grid">
      <div class="bt-link">
        <label class="bt-label" for="bt-link-input">Link zum Ergebnis</label>
        <div class="bt-link-row">
          <input
            id="bt-link-input"
            ref="linkInput"
            class="bt-input"
            readonly
            :value="berechnungsLink"
            @focus="$event.target.select()"
          />
          <button
            type="button"
            class="dlg__btn"
            @click="copyLink"
            :title="copied ? 'Kopiert' : 'Link kopieren'"
          >
            <v-icon
              :icon="copied ? 'mdi-check' : 'mdi-content-copy'"
              size="14"
            />
            {{ copied ? "Kopiert" : "Kopieren" }}
          </button>
        </div>

        <div class="dlg__note dlg__note--ok">
          <v-icon icon="mdi-shield-check-outline" size="16" />
          <span>
            <strong>Verschlüsselter Link.</strong> Das Ergebnis kann nur über
            diesen Link geöffnet werden – Dritte können es nicht einsehen.
          </span>
        </div>
      </div>

      <div class="bt-qr">
        <div class="bt-label">QR-Code scannen</div>
        <div class="bt-qr-frame">
          <QrcodeVue :value="berechnungsLink" :size="140" level="M" />
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
  import { defineProps, computed, ref } from "vue";
  import QrcodeVue from "qrcode.vue";

  const props = defineProps({
    berechnung: {
      type: Object,
      default: () => ({}),
    },
  });

  const copied = ref(false);
  const linkInput = ref(null);

  const berechnungsLink = computed(
    () =>
      `https://rechner.waizmannpro.de/vergleich/ergebnis/${props.berechnung.ber_identity_token}`
  );

  async function copyLink() {
    try {
      if (navigator.clipboard) {
        await navigator.clipboard.writeText(berechnungsLink.value);
      } else if (linkInput.value) {
        linkInput.value.select();
        document.execCommand("copy");
      }
      copied.value = true;
      setTimeout(() => (copied.value = false), 1800);
    } catch (e) {
      console.log("clipboard error", e);
    }
  }
</script>

<style scoped>
  .bt-id {
    font-weight: 500;
    color: #6b7280;
    font-size: 0.85em;
  }
  .bt-grid {
    display: grid;
    grid-template-columns: 1fr;
    gap: 16px;
  }
  @media (min-width: 720px) {
    .bt-grid {
      grid-template-columns: 1fr 200px;
      align-items: start;
    }
  }
  .bt-label {
    font-size: 10.5px;
    font-weight: 700;
    letter-spacing: 0.5px;
    text-transform: uppercase;
    color: #6b7280;
    font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas,
      monospace;
    margin-bottom: 6px;
    display: block;
  }
  .bt-link-row {
    display: flex;
    gap: 8px;
    align-items: stretch;
  }
  .bt-input {
    flex: 1 1 auto;
    min-width: 0;
    padding: 8px 10px;
    border: 1px solid #d8dde5;
    border-radius: 3px;
    background: #f7f9fc;
    color: #1f2937;
    font-size: 13px;
    font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas,
      monospace;
  }
  .bt-input:focus {
    outline: none;
    border-color: #0f4c81;
    background: #ffffff;
  }
  .bt-qr {
    text-align: center;
  }
  .bt-qr-frame {
    display: inline-flex;
    background: #ffffff;
    border: 1px solid #e5e9f0;
    border-radius: 3px;
    padding: 10px;
  }
</style>
